import type { TelephoneFieldValue } from "@jti/commerce-types";

import { toEmptyTelephoneField, toTelephoneField } from "@checkout-v2/shared/utils/telephoneUtils/toTelephoneField";

export const getSavedTelephoneDefaultValue = (
  telephoneString: string,
  isInternational: boolean,
  codes: string,
  shouldPopulatePhoneInput = true
): TelephoneFieldValue => {
  if (shouldPopulatePhoneInput && telephoneString) {
    return toTelephoneField(telephoneString, isInternational, codes);
  }

  return toEmptyTelephoneField(isInternational, codes);
};
